// Module
var code = "<a class=\"btn blue-dark subFormControl special-button special-btn\" data-bind=\"enableAttr: _enabled, click: OnClick, style: _style, tooltip: { content: HideCaption() ? Label : '' }\"> <i class=\"fa fa-slideshare\"></i><span data-bind=\"text: Label, css: {'hide-caption': HideCaption()}\"></span> </a>";
// Exports
export default code;